// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner__Spinner__1fiyk","DoubleBounce1":"Spinner__DoubleBounce1__3_-s8","DoubleBounce2":"Spinner__DoubleBounce2__2A78a","bounce":"Spinner__bounce__1zTge","Host":"Spinner__Host__3qXvE","Note":"Spinner__Note__BybDW","FlashingNote":"Spinner__FlashingNote__2G8Fi","loading":"Spinner__loading__2Ai8L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 152
// module chunks = 0